var map = {
	"./1.png": 2809,
	"./10.png": 3581,
	"./11.png": 340,
	"./12.png": 5615,
	"./13.png": 1814,
	"./2.png": 8274,
	"./3.png": 9819,
	"./4.png": 5012,
	"./5.png": 8253,
	"./6.png": 2838,
	"./7.png": 6639,
	"./8.png": 3224,
	"./9.png": 1617,
	"./IMG-20251003-WA0038.jpg": 5665,
	"./IMG-20251003-WA0042.jpg": 6886,
	"./IMG-20251003-WA0043.jpg": 19,
	"./IMG-20251003-WA0045.jpg": 5965,
	"./IMG-20251003-WA0046.jpg": 34,
	"./IMG-20251003-WA0047.jpg": 1743,
	"./IMG-20251003-WA0048.jpg": 3372,
	"./IMG-20251003-WA0049.jpg": 4425,
	"./IMG-20251003-WA0050.jpg": 1539,
	"./IMG-20251003-WA0051.jpg": 8374,
	"./IMG-20251003-WA0052.jpg": 7953,
	"./IMG-20251003-WA0053.jpg": 9908,
	"./IMG-20251003-WA0054.jpg": 4223,
	"./IMG-20251003-WA0055.jpg": 7557,
	"./IMG-20251003-WA0056.jpg": 9837,
	"./IMG-20251003-WA0057.jpg": 608,
	"./IMG-20251003-WA0059.jpg": 4942,
	"./IMG-20251003-WA0060.jpg": 5630,
	"./IMG-20251003-WA0061.jpg": 2091,
	"./IMG-20251003-WA0062.jpg": 4396,
	"./IMG-20251003-WA0063.jpg": 8121,
	"./IMG-20251003-WA0065.jpg": 8183,
	"./IMG-20251003-WA0066.jpg": 5608,
	"./IMG-20251003-WA0067.jpg": 6517,
	"./IMG-20251003-WA0068.jpg": 7286,
	"./IMG-20251003-WA0069.jpg": 8339,
	"./IMG-20251003-WA0070.jpg": 3125,
	"./IMG-20251003-WA0071.jpg": 5512,
	"./IMG-20251003-WA0072.jpg": 6439,
	"./IMG-20251003-WA0073.jpg": 5274,
	"./IMG-20251003-WA0074.jpg": 1737,
	"./IMG-20251003-WA0075.jpg": 124,
	"./IMG-20251003-WA0076.jpg": 7099,
	"./IMG-20251003-WA0077.jpg": 5790,
	"./IMG-20251003-WA0078.jpg": 3533,
	"./IMG-20251003-WA0079.jpg": 4320,
	"./IMG-20251003-WA0080.jpg": 6512,
	"./IMG-20251003-WA0081.jpg": 9965,
	"./IMG-20251003-WA0082.jpg": 1474,
	"./IMG-20251003-WA0083.jpg": 1471,
	"./IMG-20251003-WA0084.jpg": 5860,
	"./IMG-20251003-WA0085.jpg": 4385,
	"./IMG-20251003-WA0086.jpg": 6614,
	"./IMG-20251003-WA0087.jpg": 7667,
	"./IMG-20251003-WA0088.jpg": 4936,
	"./IMG-20251003-WA0089.jpg": 5845,
	"./IMG-20251003-WA0090.jpg": 287,
	"./IMG-20251003-WA0091.jpg": 3906,
	"./IMG-20251003-WA0094.jpg": 7603,
	"./IMG-20251003-WA0095.jpg": 2342,
	"./IMG-20251003-WA0096.jpg": 1953,
	"./IMG-20251003-WA0097.jpg": 3908,
	"./IMG-20251003-WA0098.jpg": 5767,
	"./IMG-20251003-WA0099.jpg": 4602,
	"./IMG-20251003-WA0100.jpg": 3485,
	"./IMG-20251003-WA0101.jpg": 2352,
	"./IMG-20251003-WA0102.jpg": 5967,
	"./IMG-20251003-WA0103.jpg": 3586,
	"./IMG-20251003-WA0104.jpg": 9073,
	"./IMG-20251003-WA0105.jpg": 1028,
	"./IMG-20251003-WA0106.jpg": 5187,
	"./IMG-20251003-WA0107.jpg": 8726,
	"./IMG-20251003-WA0108.jpg": 4213,
	"./IMG-20251003-WA0109.jpg": 696,
	"./IMG-20251003-WA0110.jpg": 7238,
	"./IMG-20251003-WA0111.jpg": 995,
	"./IMG-20251003-WA0112.jpg": 1284,
	"./IMG-20251003-WA0113.jpg": 3089,
	"./IMG-20251003-WA0114.jpg": 7858,
	"./IMG-20251003-WA0117.jpg": 7085,
	"./IMG-20251003-WA0118.jpg": 8430,
	"./IMG-20251003-WA0119.jpg": 6475,
	"./IMG-20251003-WA0120.jpg": 27,
	"./IMG-20251003-WA0121.jpg": 1982,
	"./IMG-20251003-WA0122.jpg": 9097,
	"./IMG-20251003-WA0123.jpg": 8044,
	"./IMG-20251003-WA0124.jpg": 4039,
	"./IMG-20251003-WA0125.jpg": 8202,
	"./IMG-20251003-WA0126.jpg": 8101,
	"./IMG-20251003-WA0127.jpg": 232,
	"./IMG-20251003-WA0128.jpg": 4691,
	"./IMG-20251003-WA0129.jpg": 1558,
	"./IMG-20251003-WA0130.jpg": 4796,
	"./IMG-20251003-WA0131.jpg": 6409,
	"./IMG-20251003-WA0132.jpg": 462,
	"./IMG-20251003-WA0134.jpg": 184,
	"./IMG-20251003-WA0135.jpg": 7797,
	"./IMG-20251003-WA0138.jpg": 9252,
	"./IMG-20251003-WA0139.jpg": 7297,
	"./IMG-20251003-WA0140.jpg": 2017,
	"./IMG-20251003-WA0141.jpg": 4644,
	"./IMG-20251003-WA0142.jpg": 9123,
	"./IMG-20251003-WA0143.jpg": 598,
	"./IMG-20251003-WA0144.jpg": 2045,
	"./IMG-20260718-WA0003.jpg": 7146,
	"./IMG-20260718-WA0004.jpg": 8041,
	"./IMG-20260718-WA0005.jpg": 6988,
	"./IMG-20260718-WA0006.jpg": 8971,
	"./IMG-20260718-WA0007.jpg": 926,
	"./IMG-20260718-WA0008.jpg": 9581,
	"./IMG-20260718-WA0010.jpg": 9406,
	"./IMG-20260718-WA0011.jpg": 715,
	"./IMG-20260718-WA0012.jpg": 3740,
	"./IMG-20260718-WA0013.jpg": 5353,
	"./IMG-20260718-WA0014.jpg": 8890,
	"./IMG-20260718-WA0016.jpg": 9128,
	"./IMG-20260718-WA0017.jpg": 6741,
	"./IMG-20260718-WA0018.jpg": 6630,
	"./IMG-20260718-WA0019.jpg": 1891,
	"./IMG-20260718-WA0020.jpg": 8067,
	"./IMG-20260718-WA0021.jpg": 9542,
	"./IMG-20260718-WA0022.jpg": 961,
	"./IMG-20260718-WA0023.jpg": 3588,
	"./IMG-20260718-WA0024.jpg": 4399,
	"./IMG-20260718-WA0025.jpg": 1730,
	"./IMG-20260718-WA0026.jpg": 989,
	"./aid-old.jpg": 6850,
	"./aid.jpg": 2678,
	"./disasterRelief.jpg": 860,
	"./paper_1.png": 1298,
	"./paper_2.png": 89,
	"./publicAmenities.jpg": 6604,
	"./student.jpg": 3925,
	"./studentSup-old.jpg": 1333,
	"./studentSup.jpg": 9409
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9117;